// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__LDpzm","legend__item":"Legend_legend__item__sqjjC","legend__item__color":"Legend_legend__item__color__XUDn8"};